var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.004 8.896c.02-.228.103-.442.237-.615L6.187.49c.307-.51.923-.643 1.377-.299.453.344.573 1.036.266 1.546-.042.069-.09.133-.145.19L2.285 9l5.4 7.073c.4.419.422 1.123.049 1.573-.373.45-1 .474-1.401.055a1.09 1.09 0 01-.146-.19L.241 9.718a1.202 1.202 0 01-.237-.823"
  })));
};

export default SvgLeftArrow;